import {
  GET_ONBOARDING_CONFIGURATION,
  GET_ONBOARDING_CONFIGURATION_SUCCESS,
  GET_ONBOARDING_CONFIGURATION_ERROR,
  GET_ONBOARDING_CONFIGURATION_EMPTY,
} from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetOnboardingConfiguration = (state = initialState, action) => {
  switch (action.type) {
    case GET_ONBOARDING_CONFIGURATION:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_ONBOARDING_CONFIGURATION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_ONBOARDING_CONFIGURATION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_ONBOARDING_CONFIGURATION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetOnboardingConfiguration;
